import { CircularProgress, Box } from "@mui/material";
import { FC } from "react";
import "./CustomCircularLoader.scss";
import useBlockInteraction from "../../hooks/useBlockInteraction";

interface Props {
  size?: number;
  marginRight?: string;
  marginLeft?: string;
  color?: string;
}

const CustomFullScreenCircularLoader: FC<Props> = ({
  size = 32,
  marginRight = "",
  marginLeft = "",
  color = "#c7222a",
}) => {
  useBlockInteraction(true);
  return (
    <Box
      height="90vh"
      width="100vw"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress
        size={size}
        className="custom-fullscreen-circular-loader"
        style={{
          marginRight: marginRight,
          color: color,
          marginLeft: marginLeft,
        }}
      />
    </Box>
  );
};

export default CustomFullScreenCircularLoader;
